import { z } from 'zod';
import type { ConfigDrivenProfileMessage } from './profile-message.js';

export const AccountReferenceModel = z.object({
  id: z.string().optional(),
  name: z.string(),
});
export type AccountReference = z.infer<typeof AccountReferenceModel>;

export const AccountSearchResultModel = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
  classification: z.string().optional(),
});
export type AccountSearchResult = z.infer<typeof AccountSearchResultModel>;

export type AccountProfileMessage = Required<ConfigDrivenProfileMessage>;
